module.exports = __webpack_public_path__ + "static/media/shirts1.ddf75316.jpg";